import { render, staticRenderFns } from "./ModalNewRating.vue?vue&type=template&id=25ba2958"
import script from "./ModalNewRating.vue?vue&type=script&lang=js"
export * from "./ModalNewRating.vue?vue&type=script&lang=js"
import style0 from "./ModalNewRating.vue?vue&type=style&index=0&id=25ba2958&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ba2958')) {
      api.createRecord('25ba2958', component.options)
    } else {
      api.reload('25ba2958', component.options)
    }
    module.hot.accept("./ModalNewRating.vue?vue&type=template&id=25ba2958", function () {
      api.rerender('25ba2958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/occurrences/components/ModalNewRating.vue"
export default component.exports